<template>
    <form autocomplete="off">
        <div class="row gy-3">
            <div class="col-lg-6">
                <label>Publication Type <span class="text-danger">*</span></label>
                <select class="form-select" v-model="form.type" :class="{ 'is-invalid': v$.form.type.$error }">
                    <option disabled value="">-- Select publication type --</option>
                    <option v-for="(item, index) in publicationTypes" :key="index" :value="item.value">
                        {{ item.label }}
                    </option>
                </select>
                <div class="invalid-feedback" v-for="(item, index) in v$.form.type.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>

            <div class="col-lg-6">
                <label>Year of Publication</label>
                <input type="number" min="1900" :max="new Date().getFullYear()" class="form-control"
                    placeholder="e.g. 2026" v-model="form.publication_year">
            </div>

            <div class="col-12">
                <label>Title <span class="text-danger">*</span></label>
                <input type="text" class="form-control" placeholder="Enter the publication title" v-model="form.title"
                    :class="{ 'is-invalid': v$.form.title.$error }">
                <div class="invalid-feedback" v-for="(item, index) in v$.form.title.$errors" :key="index">
                    {{ item.$message }}
                </div>
            </div>

            <div class="col-12">
                <label>Authors</label>
                <textarea rows="2" class="form-control" placeholder="e.g. John Doe, Jane Smith, Michael Johnson"
                    v-model="form.authors"></textarea>
            </div>

            <div class="col-12">
                <label>Publisher / Journal / Conference</label>
                <input type="text" class="form-control" placeholder="e.g. IEEE, Elsevier, Springer, Nature"
                    v-model="form.publisher">
            </div>

            <div class="col-12">
                <label>Abstract / Description</label>
                <textarea rows="5" class="form-control"
                    placeholder="Provide a brief summary or description of the publication"
                    v-model="form.description"></textarea>
            </div>
            <div class="col-12">
                <label for="path" class="form-label">Upload PDF <span class="text-danger">*</span></label>
                <attachment-uploader
                :maxSize="5240000"
                fileUploadType="pdf"
                acceptType="application/pdf"
                @uploadSuccess="($event) => form.pdf_path = $event.path" />
                <div v-for="(item, index) in v$.form.pdf_path.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
                <div v-if="form.pdf_path" class="mt-3 d-flex">
                    <img width="50" class="me-3" :src="absoluteUrl('/images/file-icons/pdf.svg')"/>
                    <div>
                        <small class="text-muted d-block">{{ absoluteUrl(form.pdf_path) }}</small>
                        <button @click.prevent="showPdfModal(form.pdf_path)" type="button" class="btn btn-link p-0">View PDF</button>
                    </div>
                </div>
            </div> 
            <div class="col-12">
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="primary" type="button" @click.prevent="editMode ? update() : create()">
                        {{ editMode ? 'Update' : 'Submit' }}
                    </b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { publicationTypes } from "@shared/constants/common.js";
import AttachmentUploader from './AttachmentUploader.vue';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components:{
        AttachmentUploader
    },
    props: {
        editItem: {
            type: Object,
            default: null
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                type: "",
                publication_year: "",
                title: "",
                authors: "",
                publisher: "",
                year: "",
                description: "",
                pdf_path: null
            },
            publicationTypes: publicationTypes
        }
    },
    validations() {
        return {
            form: {
                type: {
                    required: helpers.withMessage("Publication type is required", required)
                },
                title: {
                    required: helpers.withMessage("Title is required", required)
                },
                pdf_path: {
                    required: helpers.withMessage("Document path is required", required),
                },
            }
        }
    },
    methods: {
        create() {
            this.v$.$validate().then(result => {
                if (!result) {
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post('/publications/create', this.form)
                    .then(response => {
                        this.$store.dispatch("changeLoaderValue", false);
                        if (response.data.success) {
                            this.$emit("addedItem", response.data.data);
                            this.resetForm();
                        }
                    });
            });
        },
        update() {
            this.v$.$validate().then(result => {
                if (!result) {
                    this.alertError(this.v$.$errors[0].$message);
                    return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post(`/publications/${this.editItem.id}/update`, this.form)
                    .then(response => {
                        this.$store.dispatch("changeLoaderValue", false);
                        if (response.data.success) {
                            this.$emit("updatedItem", response.data.data);
                            this.resetForm();
                        }
                    });
            });
        },
        showPdfModal(item) {
            let filePath = this.absoluteUrl(item);
            this.$store.commit('TOGGLE_PDF_MODAL_FRAME', { visible: true, filePath: filePath})
        },
        resetForm() {
            this.v$.$reset();
            this.$emit("closeMe");
        }
    },
    created() {
        if (this.editMode) {
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
        }
    }
}
</script>